module.exports = __webpack_public_path__ + "media/images/front/icon_gallery_arrow-7598ae430054d62e4c5d4ee1fd5408c9.svg";